import React from "react";
import { Trash2 } from "react-feather";
import BootstrapTable from "react-bootstrap-table-next";
import { Link } from "react-router-dom/cjs/react-router-dom.min";

import { Cut } from "components/Cut";
import { TableButton } from "components/TableButton";

import "./crossTable.scss";

export const CrossTableNew = ({ cross, removeHandler, setSelected }) => {

  const tableColumns = [
    {
      dataField: "analogueCode",
      text: "Код аналога",
      formatter: (cell, row) => cell?.name,
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "brand",
      text: "Бренд",
      formatter: (cell, row) => cell?.name,
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "article",
      text: "Артикул",
      formatter: (cell, row) => {
        return row.nomenclatureId ? (
          <Link
            to={`/reference/nomenclature?search=${cell}`}
            target="_blank"
          >
            {cell}
          </Link>
        ) : (
          <>{cell}</>
        )
      },
      headerStyle: () => {
        return { width: "10%" };
      }
    },
    {
      dataField: "file",
      text: "Файл",
      formatter: (cell, row) => cell?.name,
      headerStyle: () => {
        return { width: "40%" };
      }
    },
    {
      dataField: "name",
      text: "Наименование",
      formatter: (cell, row) => <Cut>{cell}</Cut>,
      headerStyle: () => {
        return { width: "40%" };
      }
    },
    {
      dataField: "",
      text: "",
      formatter: (cell, row) => <TableButton
        Icon={Trash2}
        onClick={() => removeHandler(row.id)}
      />,
      headerStyle: () => {
        return { width: "10%" };
      }
    }
  ]

  const selectRow = {
    mode: "checkbox",
    bgColor: "#bfbfbf",
    onSelect: (row, isSelect, rowIndex, e) => {
      setSelected((prev) => {
        if (!isSelect) {
          prev.splice(
            prev.findIndex((val) => val === row.id),
            1
          );
          return [...prev];
        }
        return [...prev, row.id];
      });
    },
    onSelectAll: (isSelect, rows, e) => {
      if (!isSelect) {
        setSelected([]);
      } else {
        setSelected(cross.map((val) => val.id));
      }
    },
  };

  return (
    <>
      <BootstrapTable
        keyField="id"
        data={cross}
        columns={tableColumns}
        bootstrap4
        bordered={false}
        selectRow={selectRow}
      />
    </>
  );
};
